/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { IMentionable } from 'uplisting-frontend/utils/team-mentions';

const RESOURCE_TYPE = 'booking';

interface IArgs {
  booking: ModelRegistry['booking'];
  conversation?: ModelRegistry['team-conversation'];
  messages: ModelRegistry['team-message'][];
  mentionables?: IMentionable[];
  isLoading?: boolean;
  onPosted(message: ModelRegistry['team-message']): void;
}

interface BookingInternalMessagesSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingInternalMessagesComponent extends Component<BookingInternalMessagesSignature> {
  get resourceType(): string {
    return RESOURCE_TYPE;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::InternalMessages': typeof UiBookingInternalMessagesComponent;
  }
}
